<template>
    <div class="row">
        <div class="col-sm-1">Zone:</div>
        <div class="col-sm-2"><select class="form-select" v-model="filter.zone" @change="cambioFiltro">
                <option v-for="(zz) in zones" :key="zz.value" :value="zz.value">
                    {{ zz.label }}
                </option>
            </select>
        </div>
        <div class="col-sm-1">Class:</div>
        <div class="col-sm-4">
            <select class="form-select" v-model="filter.class" @change="cambioFiltro">
                <option value="">All</option>
                <option v-for="(cnt) in filteredClasses" :key="cnt.short_name" :value="cnt.short_name">
                    {{ cnt.label }}
                </option>
            </select>
        </div>
        <div class="col-sm-2">
            
        </div>
    </div>
</template>
<script setup>
import { onMounted, ref, defineEmits, computed } from "vue";
import data from "@/helpers/data.json";
//import vtc from "@/helpers/vtc.js";

const emit = defineEmits(["filtrado"])
const filter = ref({ class: '', zone: 0 })
const zones = [{ label: 'All', value: 0 }, { label: 'Zone 1', value: 1 }, { label: 'Zone 2', value: 2 }, { label: 'Zone 3', value: 3 }, { label: 'Zone 4', value: 4 }, { label: 'Zone 5', value: 5 }, { label: 'Zone 6', value: 6 }, { label: 'Zone 7', value: 7 }, { label: 'Zone 8', value: 8 }];
const classesFilter = ref([])

onMounted(async () => {
    let cc = [...data.construction];
    classesFilter.value = cc
});

const cambioFiltro= ()=>{
    emit("filtrado", filter.value)
}

const filteredClasses = computed(() => {
    const freturn  = new Set();
    let cc = classesFilter.value.filter(item => {
        if (freturn.has(item.short_name)) {
            return false;
        }
        freturn.add(item.short_name);
        return true;
    });

    return cc
});
</script>